export default __webpack_public_path__ + "static/media/barra.05fc1ca5.jpg";